var Sorter = /** @class */ (function () {
    function Sorter(items, sortingData) {
        this.items = items.slice();
        this.sortingData = sortingData;
    }
    Sorter.prototype.sort = function () {
        var comparator = this.getComparator();
        if (comparator) {
            this.items.sort(comparator);
        }
        return this.items;
    };
    Sorter.prototype.getComparator = function () {
        var sortableColumnConfig = this.getSortableColumnConfig(this.sortingData.sortingColumn);
        if (sortableColumnConfig === null) {
            return null;
        }
        var comparator = this.getComparatorFromSortableColumnConfig(sortableColumnConfig);
        return this.generateSignedComparator(comparator, this.sortingData.sortingDescending);
    };
    Sorter.prototype.isColumnSortable = function (columnId) {
        return !!this.getSortableColumnConfig(columnId);
    };
    Sorter.prototype.getSortableColumnConfig = function (columnId) {
        var sortableColumn = null;
        this.sortingData.sortableColumns.some(function (currentSortableColumn) {
            if (currentSortableColumn.id === columnId) {
                sortableColumn = currentSortableColumn;
                return true;
            }
        });
        return sortableColumn;
    };
    Sorter.prototype.generateFieldComparator = function (field) {
        return function (row1, row2) {
            var value1 = row1[field];
            var value2 = row2[field];
            return value1 < value2 ? -1 : value1 === value2 ? 0 : 1;
        };
    };
    Sorter.prototype.generateSignedComparator = function (comparator, descending) {
        if (comparator === null) {
            return null;
        }
        return function (row1, row2) {
            var sign = descending ? -1 : 1;
            return comparator(row1, row2) * sign;
        };
    };
    Sorter.prototype.getComparatorFromSortableColumnConfig = function (sortableColumnConfig) {
        if (sortableColumnConfig.comparator) {
            return sortableColumnConfig.comparator;
        }
        if (sortableColumnConfig.field) {
            return this.generateFieldComparator(sortableColumnConfig.field);
        }
        // TODO https://issues.amazon.com/issues/wonka-2284: raise warning when logging capabilities are added to Awsui
        return null;
    };
    return Sorter;
}());
var update = function (items, newData) {
    var sortedItems = new Sorter(items, newData).sort();
    return {
        items: sortedItems,
        sortableColumns: newData.sortableColumns,
        sortingColumn: newData.sortingColumn,
        sortingDescending: newData.sortingDescending
    };
};
var compare = function (oldSortingData, newSortingData, userAction) {
    if (!userAction) {
        return false;
    }
    return (oldSortingData.sortingColumn !== newSortingData.sortingColumn ||
        oldSortingData.sortingDescending !== newSortingData.sortingDescending);
};
var isColumnSortable = function (columnId, sortingData) {
    return new Sorter([], sortingData).isColumnSortable(columnId);
};
export default {
    update: update,
    compare: compare,
    isColumnSortable: isColumnSortable
};
//# sourceMappingURL=utils.js.map